/**
 * @module Navigation - Editable
 * @description
 */
import SiteNavigation from '~/components/core/SiteNavigation';
import { JsonObject, useMonarchSlotContext } from '@redventures/cohesion-utils-react';
import smbLpSectionNavigationEditableDefaults from './defaults';

interface Data extends JsonObject {
  showButtons: boolean;
}

const NavigationComponent = ( ) => {
  const { data } = useMonarchSlotContext<Data>();
  const {
    showButtons
  } = data ?? smbLpSectionNavigationEditableDefaults;
  return (
    <SiteNavigation showButtons={ showButtons }
    />
  );
};

NavigationComponent.displayName = 'NavigationEditable';

export default NavigationComponent;
